import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateMda } from "common/services/mda.service";
import MdaForm from "./MdaForm";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";

const UpdateMDA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name ? selectedRecord?.name.trim() : null,
      acronym: selectedRecord?.acronym ? selectedRecord?.acronym.trim() : null,
      region: {
        value: selectedRecord?.region?.id,
        label: `${selectedRecord?.region?.name}`,
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      acronym: Yup.string(),
      region: Yup.object().shape({
        value: Yup.string().required("Please select region"),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          name: values["name"],
          acronym: values["acronym"],
          region: values["region"]["value"],
        },
      };

      setLoading(true);
      try {
        await updateMda(selectedRecord?.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("MDA updated successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("MDA update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Ministry, Department or Agency
      </ModalHeader>

      <MdaForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default UpdateMDA;
